import classNames from 'classnames';
import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './SidebarStyles';
const Sidebar = (props) => {
    const { classes, className: classNameProp, appsList, activeApp, appVersion, show, hideAppLabels, testId = 'Sidebar', } = props;
    const { t } = useTranslation();
    const className = classNames(classes.root, classNameProp, {
        [classes.show]: show,
        [classes.closed]: !show,
    });
    const items = appsList.map(({ url, id, name, icon, active }) => {
        const shouldBeActiveContainer = classNames(classes.appItem, { [classes.appItemActive]: activeApp === id });
        const shouldBeActiveName = activeApp === id ? classes.nameActive : '';
        return (active && (React.createElement("a", { href: url, target: "_self", className: shouldBeActiveContainer, key: id },
            React.createElement("img", { alt: name, src: icon, className: classes.appItemImg }),
            hideAppLabels ? null : React.createElement("span", { className: classNames(classes.itemLabel, shouldBeActiveName) }, name))));
    });
    const appVersionEl = appVersion && (React.createElement("div", { className: classes.appVersion },
        React.createElement("span", { "data-testid": `${testId}-version` }, appVersion)));
    return (React.createElement("div", { className: className, "data-testid": `${testId}` },
        items,
        appVersionEl));
};
const ComposedSidebar = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    appsList: [],
    activeApp: '5',
    show: false,
}))(Sidebar);
ComposedSidebar.displayName = 'Sidebar';
export default ComposedSidebar;
//# sourceMappingURL=Sidebar.js.map